import type { NotificationModel } from "@/features/notifications/api/models/NotificationModel";
import { useHTTP, type PaginatedResponseModel } from "@/lib/http";
import { useHTTPQueryWithCursor } from "@/lib/http/useHTTPQueryWithCursor";

export const useNotifications = () => {
	const http = useHTTP("Required");

	return useHTTPQueryWithCursor({
		queryKey: ["notifications"],
		queryFn: ({ pageParam = 0 }) => {
			return http<PaginatedResponseModel<NotificationModel>>({
				method: "GET",
				url: `/notification?cursor=${pageParam}`
			});
		}
	});
};
